import React from "react";

import { css } from "@emotion/css";
import { CellContext } from "@tanstack/react-table";

import { useStyles } from "@/hooks/useStyles.ts";
import { NurseInclusionPatient } from "@/models/NurseInclusionPatientModel.ts";
import { doctorFormattedName } from "@/models/UserModel.ts";
import { Typography } from "@/uiKit/atoms/Typography.tsx";

export type DoctorNameColumnProps = CellContext<NurseInclusionPatient, unknown>;

export const DoctorNameColumn: React.FC<DoctorNameColumnProps> = ({ row: { original } }) => {
  const styles = useStyles(makeStyles);

  return (
    <Typography className={styles.container} variant="body">
      {doctorFormattedName(original.doctor.lastName, original.doctor.firstName)}
    </Typography>
  );
};

const makeStyles = () => ({
  container: css({}),
});
